// extracted by mini-css-extract-plugin
export default {"wrapper":"Navigation_wrapper__9KwLM"};